import type { CSSProperties, SVGProps } from 'react'
import classes from './icon.module.css'

export type HeightProps = SVGProps<SVGSVGElement> & {
  className?: string
  style?: CSSProperties
}
export function Height(props: HeightProps) {
  const { className, style, ...rest } = props

  const cls = `${classes.root} ${className || ''}`
  return (
    <svg
      aria-hidden="true"
      className={cls}
      focusable="false"
      viewBox="0 0 24 24"
      {...rest}
      data-testid="HeightIcon"
      style={style}
    >
      <path d="M13 6.99h3L12 3 8 6.99h3v10.02H8L12 21l4-3.99h-3z" />
    </svg>
  )
}
